import { styled } from '@mui/material/styles';
import Tab, { tabClasses } from '@mui/material/Tab';

export const TabItem = styled(Tab)(({ theme }) => ({
  opacity: 1,
  overflow: 'initial',
  borderTopLeftRadius: '8px',
  borderTopRightRadius: '8px',
  marginRight: '.3rem',
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.grey['300'],
  transition: '0.2s',
  zIndex: 2,
  marginTop: theme.spacing(0.5),
  textTransform: 'initial',
  minHeight: '30px',
  height: '30px',
  fontWeight: 'bold',
  '&:before': {
    transition: '0.2s',
  },
  '&:last-of-type': {
    marginRight: 0,
  },
  [`& + .${tabClasses.selected}::before`]: {
    opacity: 0,
  },
  '&:hover': {
    [`&:not(.${tabClasses.selected})`]: {
      backgroundColor: 'rgba(0 0 0 / 0.2)',
    },
    '&::before': {
      opacity: 0,
    },
    [`& + .${tabClasses.root}::before`]: {
      opacity: 0,
    },
  },
  [`&.${tabClasses.selected}`]: {
    backgroundColor: theme.palette.common.white,
  },
  [`&.${tabClasses.selected} + .${tabClasses.root}`]: {
    zIndex: 1,
  },
  [`&.${tabClasses.selected} + .${tabClasses.root}::before`]: {
    opacity: 0,
  },
}));
